import { createFeature, createReducer, on } from '@ngrx/store'
import * as scActions from './salary-components.actions'
import { initialState } from './salary-components.state'

export const salaryComponentsReducer = createReducer(
  initialState,

  on(scActions.loadSalaryComponents, state => ({
    ...state,
    loading: true,
    error: null
  })),

  on(scActions.loadSalaryComponentsSuccess, (state, { componentType, salaryComponents }) => ({
    ...state,
    loading: false,
    salaryComponents: {
      ...state.salaryComponents,
      [componentType]: salaryComponents
    }
  })),

  on(scActions.loadSalaryComponentsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),

  //Add
  on(scActions.addSalaryComponentSuccess, (state, { salaryComponent }) => ({
    ...state,
    salaryComponents: {
      ...state.salaryComponents,
      [salaryComponent.componentType]: [
        ...(state.salaryComponents[salaryComponent.componentType] || []),
        salaryComponent
      ]
    }
  })),

  on(scActions.addSalaryComponentFailure, (state, { error }) => ({
    ...state,
    error
  })),

  //Edit
  on(scActions.editSalaryComponentSuccess, (state, { salaryComponent }) => ({
    ...state,
    salaryComponents: {
      ...state.salaryComponents,
      [salaryComponent.componentType]: state.salaryComponents[salaryComponent.componentType]
        ? state.salaryComponents[salaryComponent.componentType].map(item =>
            item.id === salaryComponent.id ? salaryComponent : item
          )
        : [salaryComponent]
    }
  })),

  on(scActions.editSalaryComponentFailure, (state, { error }) => ({
    ...state,
    error
  })),

  //Delete
  on(scActions.deleteSalaryComponentSuccess, (state, { id, componentType }) => {
    const updatedSalaryComponents = state.salaryComponents[componentType].filter(
      component => component.id !== id
    )
    return {
      ...state,
      salaryComponents: {
        ...state.salaryComponents,
        [componentType]: updatedSalaryComponents
      }
    }
  }),

  on(scActions.deleteSalaryComponentFailure, (state, { error }) => ({
    ...state,
    error
  }))
)

export const salaryComponentFeature = createFeature({
  name: 'salaryComponents',
  reducer: salaryComponentsReducer
})

export const { name, reducer, selectLoading, selectError, selectSalaryComponentsState } =
  salaryComponentFeature
